<template>
  <div class="super-admins">
    <MainHeader
        class="super-admins__header"
        title="Администраторы"
        :number="listAdmins.admins?.length ? listAdmins.admins_count : ''"
        btnText="Новый администратор"
        @btnClick="$router.push(`/super-admins/new${queryParams}`)"
    />
    <div class="super-admins__row">
      <div class="super-admins__segmented-control">
        <VSegmentedControlQuery
            :items="filteringOptions"
        />
      </div>
      <VDefaultInput
          v-model="search"
          placeholder="Поиск администратора"
          border
          class="super-admins__search"
      >
        <template #iconLeft>
          <img src="@/assets/images/icons/search.svg" alt="search"/>
        </template>
        <template #iconRight>
          <div
              class="super-admins__search-clear"
              v-if="search"
              @click="clearSearch"
          >
            <img src="@/assets/images/icons/x.svg" alt="search"/>
          </div>
        </template>
      </VDefaultInput>
    </div>

    <div class="super-admins__no-content" v-if="errorGet">
      <VNoContent
          title="Ошибка"
          description="Произошла ошибка. Пожалуйста, попробуйте позже"
      />
    </div>

    <div class="companies__content">
      <div class="super-admins__cards">
        <VSkeleton v-if="skeleton" v-for="item in  [...Array(9).keys()]" height="92" variants="CARD" />
      </div>
    </div>
    <div class="companies__content" v-if="!errorGet && !skeleton && listAdmins.admins">
      <div class="super-admins__cards" v-if="listAdmins.admins.length">
        <SuperAdminCard
            class="super-admins__card"
            v-for="admin in listAdmins.admins"
            :key="admin.id"
            :card="admin"/>


      </div>
      <div class="super-admins__no-content" v-else>
        <VNoContent
            v-if="!search"
            title="Список администраторов пуст"
            description="По выбранному фильтру ничего не найдено"
        />
        <VNoContent
            v-if="search"
            title="Ничего не найдено"
            description="Проверьте пожалуйста, правильно ли вы написали название"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import admins from "@/api/admins";
import {ref, onMounted, watch, computed} from "vue";

import MainHeader from "@/components/MainHeader";
import SuperAdminCard from '@/components/SuperAdminCard';
import VacancyCard from "@/components/VacancyCard/index.vue";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";
import VSegmentedControlQuery from "@/components/UI/VSegmentedControlQuery/index.vue";
import {useRoute, useRouter} from "vue-router";

const route = useRoute();
const router = useRouter()

const filteringOptions = [
  {
    id: "all",
    label: "Все",
  },
  {
    id: "0",
    label: "Активные",
  },
  {
    id: "1",
    label: "Заблокированные",
  },
];
const activeFilter = ref("all");
const search = ref("");
const errorGet = ref(false)
const skeleton = ref(true)

const listAdmins = ref([])
const getAdmins = async () => {
  let params = ''
  if (route.query?.tabs === "all") {
    params = {}
  } else {
    params = { is_blocked: route.query?.tabs };
  }
  params.search = route.query?.search;
  try {
    skeleton.value = true
    listAdmins.value = await admins.getAdmins(params)
    skeleton.value = false
  } catch (error) {
    errorGet.value = true
    console.log(error)
  }
}

const updateParamsInQuery = () => {
  search.value = route.query?.search;
}

onMounted(() => {
  updateParamsInQuery()
  getAdmins()
})

const clearSearch = () => {
  search.value = "";
  getAdmins()
};

watch(search, (newValue) => {
  router.replace({query: {...route.query, search: newValue}});
})

watch(() => route.query, (newValue) => {
  getAdmins()
}, {deep: true})

const queryParams = computed(() => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(route.query)) {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  }
  return '?' + searchParams.toString()
})
</script>

<style scoped lang="scss">
.super-admins {
  &__header {
    margin-top: 32px;
  }

  &__row {
    margin-top: 24px;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
  }

  &__search {
    width: 437px;

    &::v-deep(.v-input__input) {
      &::placeholder {
        color: $dark-blue;
        opacity: 1;
      }
    }
  }

  &__search-clear {
    cursor: pointer;
  }

  &__cards {
    margin-top: -1.5%;
    margin-left: -32px;
    display: flex;
    flex-wrap: wrap;
  }

  &__card {
    width: calc(33.333% - 32px);
    margin-top: 1.5%;
    margin-left: 32px;
  }

  &__no-content {
    width: 100%;
    height: calc(100vh - 543px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__segmented-control {
    width: 640px;
  }
}
</style>
